import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Picker } from 'emoji-mart';
if (!customElements.get('em-emoji-picker')) {
  customElements.define('em-emoji-picker', Picker as unknown as CustomElementConstructor);
}
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { provideFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager, memoryLocalCache } from '@angular/fire/firestore';
import { provideAuth, initializeAuth, indexedDBLocalPersistence, browserLocalPersistence, browserPopupRedirectResolver } from '@angular/fire/auth';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { Capacitor } from '@capacitor/core';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideAnimations(),
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => initializeFirestore(getApp(), {
      // On iOS WKWebView, IndexedDB is slow to initialise and causes all Firestore
      // operations to queue indefinitely. Use in-memory cache on native; the full
      // persistent cache is fine in a real browser where IndexedDB is reliable.
      localCache: Capacitor.isNativePlatform()
        ? memoryLocalCache()
        : persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
    })),
    provideAuth(() => initializeAuth(getApp(), {
      // browserLocalPersistence (localStorage) initialises synchronously on iOS,
      // so onAuthStateChanged fires immediately and Firestore auth tokens are
      // available without delay. indexedDBLocalPersistence causes the JS SDK to
      // stall on WKWebView, making every Firestore/CF call hang until it resolves.
      persistence: Capacitor.isNativePlatform()
        ? browserLocalPersistence
        : indexedDBLocalPersistence,
      popupRedirectResolver: browserPopupRedirectResolver,
    })),
    provideStorage(() => getStorage()),
    provideFunctions(() => getFunctions(undefined, 'asia-southeast1')),
    // Analytics is web-only; native uses @capacitor-firebase/analytics via AnalyticsService
    ...(!Capacitor.isNativePlatform() ? [provideAnalytics(() => getAnalytics())] : []),
  ],
});
